

/* Retorna todos os pagamentos em dinheiro */
export const readAllPayments = ({ all_payments }) => all_payments;

export const readCurrentPageOfPagination = ({ current_page_of_pagination }) => current_page_of_pagination;

export const readCurrentKeyRefreshComponents = ({ current_key_refresh_components }) => current_key_refresh_components;

export const isServicesLoadedInIndex = ({ is_services_loaded_in_index_component }) => is_services_loaded_in_index_component;

/* Retorna todos os resgates em aberto */
export const allRescuesOpen = ({ all_rescues_open }) => all_rescues_open;

/* Retorna os créditos disponíveis para resgate */
export const availableForRedemption = ({ available_for_redemption }) => available_for_redemption;

/* Retorna os créditos em análise revisão */
export const creditsUnderReview = ({ credits_under_review }) => credits_under_review?.data;

/* Retorna os detalhes dos créditos resgatados */
export const creditsRescuedDetails = ({ credits_rescued_details }) => credits_rescued_details; 

export const allRescuesClosed = ({ all_rescues_closed }) => all_rescues_closed;

/* Os valores monetários podem ser exibidos? */
export const isMoneyVisible = ({ is_money_visible }) => is_money_visible;

export const lastPageOfPagination = ({ last_page_of_pagination }) => last_page_of_pagination;

export const isReloadingComponents = ({ is_reloading_components }) => is_reloading_components;
